import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDown } from 'lucide-react';
import { useChatSearchStore } from '../../store/chatSearchStore';
import './ChatSearch.css';

/**
 * "Jump to present" pill over the composer, shown after a search jump left
 * the reader somewhere in the past. Reaching the bottom (by scrolling or by
 * this button) hides it.
 */
export default function ChatJumpToPresent({ onJump }) {
  const { t } = useTranslation();
  const visible = useChatSearchStore((s) => s.jumpedAway);
  if (!visible) return null;
  return (
    <button type="button" className="chat-jump-present" onClick={onJump}>
      {t('chat.search.jumpToPresent')}
      <ArrowDown size={13} />
    </button>
  );
}
